import {gql, useQuery} from '@apollo/client';
import {toRelayId} from 'graphqlsupport';
import type {Offer} from '../domain/types';
import {REFERRAL_DETAIL_FOR_PROVIDER_FRAGMENT} from 'providerapp/hook/useReferralQueryForProvider$';
import {OfferContentFragment, StatusAndSubmitter} from '../domain/graphql';


type OfferAndReferralInput = {
    offerId: string;
};
type OfferAndReferralResult = {
    offer: Offer;
};
const OFFER_AND_REFERRAL_BY_CURSOR_QUERY = gql`
query OfferAndReferral($offerId: ID!) {
  offer(id: $offerId) {
    id
    guid
    conversationSummary {
      urgent
      hasConversation
      providerUnreadCount
      clientPlacementTeamUnreadCount
    }
    provider {
      name
    }
    ...${OfferContentFragment.name}
    ...${StatusAndSubmitter.name}
    referral {
      ...${REFERRAL_DETAIL_FOR_PROVIDER_FRAGMENT.name}
    }
  }
}
${OfferContentFragment.value}
${StatusAndSubmitter.value}
${REFERRAL_DETAIL_FOR_PROVIDER_FRAGMENT.value}
`;


export const useOfferByGuid = (offerGuid: string, skip = false) => {
    return useQuery<OfferAndReferralResult, OfferAndReferralInput>(OFFER_AND_REFERRAL_BY_CURSOR_QUERY, {
        variables: {
            offerId: toRelayId(offerGuid, 'Offer')
        },
        skip,
        fetchPolicy: 'no-cache',
    });
};
